import { html, LitElement, TemplateResult } from "lit";
import { customElement, property, queryAll } from "lit/decorators.js";

export interface RadioOption {
    value: string;
    label: string;
    description?: string;
}

@customElement('radio-input')
export class RadioInput extends LitElement {

    // Props

    @property({ type: Boolean, reflect: true })
    required: boolean = false;

    @property({ type: String })
    name: string = '';

    @property({ type: String })
    value?: string = null;

    @property({ type: Array })
    options: RadioOption[] = [];

    @queryAll('input')
    _inputs?: NodeListOf<HTMLInputElement>;

    // Lifecycle Hooks

    connectedCallback() {
        super.connectedCallback();
        this.classList.add('RadioInput');
    }

    // Render

    render() {
        return html`
            ${ this.options.map((option, i) => this.optionTemplate(option, i)) }
        `;
    }

    createRenderRoot() { 
        return this;
    }

    // Templates

    optionTemplate(option: RadioOption, i: number): TemplateResult {
        return html`
            <div class="RadioInput-option">
                <input
                    type="radio"
					id="radio-${ this.name }-${ i }"
                    name="${ this.name }"
                    value="${ option.value }"
                    ?required="${ this.required }"
                    ?checked="${ option.value == this.value }"
                    @change="${ this._handleChange }"
                />
                <label for="radio-${ this.name }-${ i }">
                    ${ option.label }
                    ${ option.description ? html`<span class="RadioInput-description">${ option.description }</span>` : '' }
                </label>
            </div>
        `;
    }

    // Methods

    private _handleChange() {
        this.value = (this._inputs)
            ? [...this._inputs].find((input) => input.checked)?.value
            : null;
        const event = new Event('change');
        this.dispatchEvent(event);
    }

}